module.exports = {
  development: {
    baseUrl: "https://test.wisecotech.com:7000",
    mockUrl: "https://xxxx",
  },
  production: {
    baseUrl: "https://xxxx",
    mockUrl: "https://xxxx",
  },
};
 